export default __webpack_public_path__ + "static/media/OMSC_06.1198286a.gif";